import { Injectable } from '@angular/core';
import { User } from '../classes/user';

@Injectable()
export class GlobalService {
  public user: User;
  public isIE: boolean = false;

  constructor() { }

  public isUserAuthenticated(): boolean {
    const isAuthed = localStorage.getItem('accessToken') ? true : false;
    if (!isAuthed) {
      this.user = null;
    }
    return isAuthed;
  }

  public checkIE(): any {
    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      this.isIE = true;
    }
  }
}
